import { Component } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { VisuallyHidden } from '@workramp/ui';
import { academyCustomCSS } from '~/constants/academyCustomCSS';
import { I18n } from '~/common/explicit-exports';
import { KeyCodes } from '~/keycodes';
import ClickOff from '../click-off';
import withDropdownStateManagement from '../with-dropdown-state-management';
import withActiveItemNavigation from '../with-active-item-navigation';
import SearchBar from './search-bar';
import SearchBarDropdown from './search-bar-dropdown';

class _StatelessDropdownEnabledSearchBar extends Component {
  componentDidUpdate(prevProps, _prevState) {
    if (this.props.searching && !prevProps.searching) this.props.showResults();
  }

  render() {
    const { placeholder, search, searching, emptyText, activeIndex, onReset, allowReset, results } = this.props;
    const searchIDAttr = uuidv4();

    const dropdown = this.showDropdown() ? (
      <SearchBarDropdown
        activeIndex={activeIndex}
        controlledQuery={this.props.controlledQuery}
        emptyText={emptyText}
        isWithinModal={this.props.isWithinModal}
        results={results}
        renderResult={this.props.renderResult}
        searching={searching}
        showAdvancedSearchOption={this.props.showAdvancedSearchOption}
        accessibilityProps={{
          id: searchIDAttr,
          role: 'listbox',
        }}
      />
    ) : undefined;
    const searchingClass = this.showDropdown() ? ' searching' : '';
    return (
      <>
        <VisuallyHidden aria-live="assertive">
          {results?.length
            ? I18n.t('js.academy.navigation.search_results_found', {
                count: results.length,
              })
            : ''}
        </VisuallyHidden>
        <ClickOff onDOMClick={this.handleBlur}>
          <div className={`dropdown-enabled-search-bar ${searchingClass} ${academyCustomCSS.header.searchBar}`}>
            <SearchBar
              allowReset={allowReset}
              controlledQuery={this.props.controlledQuery}
              iconWhenUnused={this.props.iconWhenUnused}
              onFocus={this.handleFocus}
              onKeyDown={this.handleKeyDown}
              onReset={onReset}
              placeholder={placeholder}
              search={search}
              showDropdown={this.props.reshowDropdown}
              clearActive={this.props.clearActive}
              showAdvancedSearchOption={this.props.showAdvancedSearchOption}
              searchWithinUniversity={this.props.searchWithinUniversity}
              updateControlledQuery={this.props.updateControlledQuery}
              debouncedSearchTime={this.props.debouncedSearchTime}
              accessibilityProps={{
                role: 'combobox',
                'aria-autocomplete': 'none',
                'aria-expanded': !!this.showDropdown(),
                'aria-controls': searchIDAttr,
              }}
            />
            {dropdown}
          </div>
        </ClickOff>
      </>
    );
  }

  handleKeyDown = (e) => {
    const { activeIndex, controlledQuery, results, showAdvancedSearchOption } = this.props;

    // if enter pressed while "show full results" option is active
    if (e.which === KeyCodes.ENTER && results && activeIndex === results.length && showAdvancedSearchOption) {
      const queryParam = controlledQuery ? `?query=${controlledQuery}` : '';
      window.location = `/advanced_search/${queryParam}`;
    }

    this.props.onKeyDown(e, this.props.handleItemSelect, this.props.hideResults);
  };

  showDropdown = () => {
    if (this.props.hideDropdown) return false;
    const { results, searching, allowDropdown } = this.props;
    return allowDropdown && (results || searching);
  };

  handleFocus = () => {
    const { onFocus } = this.props;
    if (typeof onFocus === 'function') onFocus();
    this.props.showResults();
  };

  handleBlur = () => {
    const { onBlur } = this.props;
    if (typeof onBlur === 'function') onBlur();
    this.props.hideResults();
  };
}

const DropdownEnabledSearchBar = withDropdownStateManagement(
  withActiveItemNavigation(_StatelessDropdownEnabledSearchBar),
);
export default DropdownEnabledSearchBar;
